// /terms — STRUCTURED PLACEHOLDER. The headings are the sections a real terms
// of use needs; the wording under them has not been through counsel, which is
// why the page carries a visible "Draft — to be reviewed" banner. Replace the
// bodies (publicPages.terms_p*) before this is treated as binding.

import { useTranslation } from 'react-i18next';
import PublicPage, { Section } from './PublicPage';

const CLAUSES = [1, 2, 3, 4, 5, 6];

export default function Terms() {
  const { t } = useTranslation('publicPages');
  return (
    <PublicPage
      testId="terms-page"
      title={t('publicPages.terms_title')}
      lead={t('publicPages.terms_lead')}
      note={t('publicPages.draft_note')}
    >
      {CLAUSES.map((n) => (
        <Section key={n} heading={t(`publicPages.terms_h${n}`)} testId={`terms-clause-${n}`}>
          <p>{t(`publicPages.terms_p${n}`)}</p>
        </Section>
      ))}
    </PublicPage>
  );
}
